// Central config for the 5 sites: theme tokens, fonts, hero images, page maps.
export const SITES = {
  "bad-credit": {
    key: "bad-credit",
    name: "Mon Prêt Autos",
    tagline: "Votre projet auto, notre priorité.",
    logo: "/media/site-assets/bad-credit-logo.png",
    domain: "monpretautos.ca",
    phone: "514-418-3968",
    address: "1007 Boul René-Lévesque, Verdun, QC H3E 0H1",
    theme: {
      primary: "#2563EB",
      primaryHsl: "221 83% 53%",
      accent: "#0F1D3D",
      background: "#0A1428",
      surface: "#111E3B",
      surfaceElevated: "#182A54",
      text: "#F8FAFC",
      muted: "#94A3B8",
      fontHeading: "Manrope",
      fontBody: "Inter",
      radius: "1rem",
      dark: true,
      segmentBadge: "TOUTES SITUATIONS",
      segmentBadgeColor: "#2563EB",
    },
    hero: "/media/site-assets/bad-credit-hero.jpg",
    about: "/media/site-assets/bad-credit-about.jpg",
    pages: {
      home: { path: "", labelFr: "Accueil", labelEn: "Home" },
      "bad-credit-loan": { path: "bad-credit-loan", labelFr: "Prêt mauvais crédit", labelEn: "Bad Credit Loan" },
      "second-chance": { path: "second-chance", labelFr: "Deuxième chance", labelEn: "Second Chance" },
      "bankruptcy-proposal": { path: "bankruptcy-proposal", labelFr: "Faillite / Proposition", labelEn: "Bankruptcy / Proposal" },
      apply: { path: "apply", labelFr: "Faire une demande", labelEn: "Apply Online" },
      faq: { path: "faq", labelFr: "FAQ", labelEn: "FAQ" },
      contact: { path: "contact", labelFr: "Contact", labelEn: "Contact" },
    },
  },
  approval: {
    key: "approval",
    name: "Rétablirmoncredit.com",
    tagline: "Toujours là pour vous tendre la main.",
    logo: "/media/logos/rmc-800.png",
    domain: "retablirmoncredit.com",
    phone: "514-418-3968",
    address: "1007 Boul René-Lévesque, Verdun, QC H3E 0H1",
    theme: {
      primary: "#0369A1",
      primaryHsl: "201 94% 32%",
      accent: "#E0F2FE",
      accentWarm: "#D97706",
      accentWarmHover: "#B45309",
      background: "#FFFFFF",
      surface: "#F8FAFC",
      surfaceElevated: "#FFFFFF",
      text: "#0F172A",
      muted: "#64748B",
      border: "rgba(15,23,42,0.08)",
      shadow: "0 12px 40px -12px rgba(3, 105, 161, 0.15)",
      shadowLg: "0 24px 60px -20px rgba(3, 105, 161, 0.28)",
      fontHeading: "Manrope",
      fontBody: "Inter",
      radius: "1rem",
      dark: false,
      segmentBadge: "COMPARATEUR",
      segmentBadgeColor: "#0369A1",
      isMarketplace: true,
    },
    hero: "/media/hero/rmc-hero.webp",
    about: "/media/site-assets/approval-about.jpg",
    pages: {
      home: { path: "", labelFr: "Accueil", labelEn: "Home" },
      situations: { path: "situations", labelFr: "Situations", labelEn: "Situations" },
      lenders: { path: "lenders", labelFr: "Solutions", labelEn: "Solutions" },
      guides: { path: "guides", labelFr: "Articles", labelEn: "Articles" },
      simulator: { path: "outils", labelFr: "Calculatrices", labelEn: "Calculators" },
      monPlan: { path: "mon-plan", labelFr: "Mon plan", labelEn: "My plan" },
      apply: { path: "apply", labelFr: "Vérifier mon admissibilité", labelEn: "Check my eligibility" },
      faq: { path: "faq", labelFr: "FAQ", labelEn: "FAQ" },
      contact: { path: "contact", labelFr: "Contact", labelEn: "Contact" },
    },
  },
  rebuild: {
    key: "rebuild",
    name: "Rétablir Mon Crédit",
    tagline: "Aujourd'hui pour un meilleur demain.",
    logo: "/media/site-assets/rebuild-logo.png",
    domain: "retablirmoncredit.ca",
    phone: "514-418-3968",
    address: "1007 Boul René-Lévesque, Verdun, QC H3E 0H1",
    theme: {
      primary: "#2BA84A",
      primaryHsl: "132 59% 41%",
      accent: "#1E3A66",
      background: "#061428",
      surface: "#0D2138",
      surfaceElevated: "#173156",
      text: "#F0FDF4",
      muted: "#94A3B8",
      fontHeading: "Manrope",
      fontBody: "Inter",
      radius: "1rem",
      dark: true,
      segmentBadge: "RÉTABLIR SON CRÉDIT",
      segmentBadgeColor: "#2BA84A",
    },
    hero: "/media/site-assets/rebuild-hero.jpg",
    about: "/media/site-assets/rebuild-about.jpg",
    pages: {
      home: { path: "", labelFr: "Accueil", labelEn: "Home" },
      "rebuild-credit": { path: "rebuild-credit", labelFr: "Rebâtir mon crédit", labelEn: "Rebuild Credit" },
      "second-chance": { path: "second-chance", labelFr: "Deuxième chance", labelEn: "Second Chance" },
      "how-it-works": { path: "how-it-works", labelFr: "Comment ça fonctionne", labelEn: "How It Works" },
      apply: { path: "apply", labelFr: "Faire une demande", labelEn: "Apply Online" },
      faq: { path: "faq", labelFr: "FAQ", labelEn: "FAQ" },
      contact: { path: "contact", labelFr: "Contact", labelEn: "Contact" },
    },
  },
};

export const SITE_LIST = Object.values(SITES);
